import {Accordion, AccordionDetails, AccordionSummary, Card} from '@mui/material';
import React, {useEffect, useRef} from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function AccordionWrapper({card = false, sx = {}, parent, children, error = false}) {
	// expandIcon={<ExpandMoreIcon />}
	return (
		<Accordion sx={{p: 0, m: 0, flex: 1, ...sx}}>
			{card ? (
				<Card>
					<AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{p: 0, px: 3, m: 0, flex: 1}}>
						{parent}
					</AccordionSummary>
				</Card>
			) : (
				<AccordionSummary
					expandIcon={<ExpandMoreIcon sx={{color: error && '#ff3333'}} />}
					sx={{p: 0, pr: 1, m: 0, flex: 1, color: error && '#ff3333'}}
				>
					{parent}
				</AccordionSummary>
			)}

			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
}
